import type { RetirementCalculatorInputs as RetirementCalculatorInputsData } from '@fruitful/financial-calculators';
import React from 'react';
import { YStack } from 'smoothie';

import { GroveSimpleModal } from '../../common/components/GroveSimpleModal';
import { RetirementCalculatorInputs } from './RetirementCalculatorInputs';

interface RetirementCalculatorInputsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCalculate: (inputs: RetirementCalculatorInputsData) => Promise<void>;
    isCalculating: boolean;
    initialData: RetirementCalculatorInputsData;
}

export const RetirementCalculatorInputsModal = ({
    isOpen,
    onClose,
    onCalculate,
    isCalculating,
    initialData,
}: RetirementCalculatorInputsModalProps) => {
    return (
        <GroveSimpleModal
            isOpen={isOpen}
            onClose={onClose}
            hasCloseButton={true}
        >
            <YStack height="80vh">
                <RetirementCalculatorInputs
                    onCalculate={onCalculate}
                    isCalculating={isCalculating}
                    initialData={initialData}
                />
            </YStack>
        </GroveSimpleModal>
    );
};
